module.exports = __webpack_public_path__ + "static/media/Spectacles.3788f4db.jpg";